import { Button } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";

import { useTestAuthApi } from "@/lib/queries/use-test-auth-api";

export default function AdminDashboard() {
  const { signOut } = useAuth();
  const testApiMutation = useTestAuthApi();

  return (
    <div className="min-h-[70vh]">
      <header className="border-b bg-card/60 backdrop-blur supports-[backdrop-filter]:bg-card/60">
        <div className="container mx-auto px-6 py-5 flex items-center justify-between">
          <h1 className="text-xl font-semibold">Admin</h1>
          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              onClick={() => testApiMutation.mutate()}
              disabled={testApiMutation.isPending}
            >
              {testApiMutation.isPending ? "Testing…" : "Test Auth API"}
            </Button>
            <Button onClick={() => signOut()}>Sign out</Button>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-8 space-y-6">
        {testApiMutation.data && (
          <div className="p-4 bg-secondary rounded-lg">
            <h3 className="font-semibold mb-2">API Response:</h3>
            <pre className="text-sm overflow-auto">
              {JSON.stringify(testApiMutation.data, null, 2)}
            </pre>
          </div>
        )}

        {testApiMutation.error && (
          <div className="p-4 bg-secondary rounded-lg">
            <h3 className="font-semibold mb-2 text-destructive">Error:</h3>
            <pre className="text-sm overflow-auto text-destructive">
              {testApiMutation.error.message}
            </pre>
          </div>
        )}
      </main>
    </div>
  );
}
